export var ASTERISK = '*';